var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bgimg" }, [
    _c("img", { staticClass: "coming-soon", attrs: { src: _vm.image } }),
    _c(
      "div",
      { staticClass: "middle" },
      [
        _c("h1", { staticClass: "header" }, [_vm._v("COMING SOON")]),
        _c("sui-divider"),
        _c("div", { staticClass: "countdown" }, [
          _c("div", { staticClass: "block" }, [
            _c("p", { staticClass: "digit" }, [
              _vm._v(_vm._s(_vm._f("twoDigits")(_vm.days))),
            ]),
            _c("p", { staticClass: "text" }, [_vm._v("Days")]),
          ]),
          _c("div", { staticClass: "block" }, [
            _c("p", { staticClass: "digit" }, [
              _vm._v(_vm._s(_vm._f("twoDigits")(_vm.hours))),
            ]),
            _c("p", { staticClass: "text" }, [_vm._v("Hours")]),
          ]),
          _c("div", { staticClass: "block" }, [
            _c("p", { staticClass: "digit" }, [
              _vm._v(_vm._s(_vm._f("twoDigits")(_vm.minutes))),
            ]),
            _c("p", { staticClass: "text" }, [_vm._v("Minutes")]),
          ]),
          _c("div", { staticClass: "block" }, [
            _c("p", { staticClass: "digit" }, [
              _vm._v(_vm._s(_vm._f("twoDigits")(_vm.seconds))),
            ]),
            _c("p", { staticClass: "text" }, [_vm._v("Seconds")]),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }